import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="copyright">
          {currentYear} <em>好室工作室. 版權所有</em>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
